import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TJotformListItem } from '../../../redux/reducers/jotform/types';
import { DATES, DATES_ID } from '../../../services/constants/dates-constants';

export const tableStructure: TTableStructure<keyof TJotformListItem>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Company name',
		selector: 'company',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'TIN/Business ID',
		selector: 'companyRegistration',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Contact Person',
		selector: 'contactName',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Contact Email',
		selector: 'confirmEmail',
		show: true,
		sortable: true,
		filterable: false,
		searchable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Site',
		selector: 'websiteUrl',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Created At',
		selector: 'createdAt',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
	},
	{
		name: 'Submission ID',
		selector: 'submissionId',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions' as keyof TJotformListItem,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [
			{
				name: 'Register EM',
			},
		],
	},
];
